// Etiquetas del IVA de una factura de vouchers (tratamiento + alicuota WSFE).
export const TRATAMIENTO_IVA_LABEL = { EXENTO: "Exento", NO_ALCANZADO: "No alcanzado", NO_CORRESPONDE: "No corresponde" };
// Codigos WSFE de alicuota. Las facturas anteriores sin alicuota guardada son al 21 %.
export const PORCENTAJE_ALICUOTA = { 3: 0, 4: 10.5, 5: 21, 6: 27, 8: 5, 9: 2.5 };

export const formatPorcentaje = (porcentaje) => `${String(porcentaje).replace(".", ",")} %`;

export const porcentajeAlicuota = (alicuotaIvaId) => PORCENTAJE_ALICUOTA[alicuotaIvaId] ?? 21;

export const ivaLabel = (tratamientoIva, alicuotaIvaId) => (tratamientoIva === "GRAVADO"
	? `Gravado ${formatPorcentaje(porcentajeAlicuota(alicuotaIvaId))}`
	: TRATAMIENTO_IVA_LABEL[tratamientoIva] || "");

// Refleja la selección explícita, también para C. No adapta IVA a la letra.
export const previewImportes = ({ total, tipoFactura, opcionIva }) => {
	const totalCents = Math.round(Number(total || 0) * 100);
	if (!(totalCents > 0) || !tipoFactura || !opcionIva) return null;
	const importeTotal = totalCents / 100;
	if (opcionIva.tratamientoIva === "NO_CORRESPONDE") return { neto: importeTotal, iva: 0, sinIva: 0, total: importeTotal };
	if (opcionIva.tratamientoIva !== "GRAVADO") return { neto: 0, iva: 0, sinIva: importeTotal, total: importeTotal };
	const neto = Math.round(totalCents / (1 + Number(opcionIva.porcentaje || 0) / 100));
	return { neto: neto / 100, iva: (totalCents - neto) / 100, sinIva: 0, total: importeTotal };
};
